import { type DateFormat, type TimeFormat } from '@ledium/types';
import { Socket } from 'socket.io-client';

export const ZONE_STORAGE_KEY = 'ledium:selectedZoneId';

export type UserStatus = 'LOGGED_IN' | 'LOGGED_OUT' | null;

export interface UserData {
    auth: boolean;
    username?: string;
    admin?: boolean;
    status: UserStatus;
}

export interface GlobalState {
    socket: Socket | null;
    loading: boolean;
    userData: UserData;
    apiError?: unknown;
    dateFormat: DateFormat | null;
    timeFormat: TimeFormat | null;
    dateTimeFormatLoaded: boolean;
    isOnline: boolean;
    socketConnected: boolean;
    offlineMode: boolean;
    serverTimeOffset: number;
    selectedGroupId: string | null;
    previousGroupId: string | null;
    dashboardGroupId: string | null;
}

export default {
    socket: null,
    loading: false,
    userData: {} as UserData,
    dateFormat: null,
    timeFormat: null,
    dateTimeFormatLoaded: false,
    isOnline: true,
    socketConnected: true,
    offlineMode: false,
    serverTimeOffset: 0,
    selectedGroupId: localStorage.getItem(ZONE_STORAGE_KEY),
    previousGroupId: null,
    dashboardGroupId: null
} satisfies Partial<GlobalState>;
